export const UN_REVIEW_INVOICE_DATA_REQUEST = "UN_REVIEW_INVOICE_DATA_REQUEST";
export const UN_REVIEW_INVOICE_DATA_SUCCESS = "UN_REVIEW_INVOICE_DATA_SUCCESS";
export const UN_REVIEW_INVOICE_DATA_FAILURE = "UN_REVIEW_INVOICE_DATA_FAILURE";


export const REVIEW_INVOICE_DATA_REQUEST = "REVIEW_INVOICE_DATA_REQUEST";
export const REVIEW_INVOICE_DATA_SUCCESS = "REVIEW_INVOICE_DATA_SUCCESS";
export const REVIEW_INVOICE_DATA_FAILURE = "REVIEW_INVOICE_DATA_FAILURE";


// Invoice Approve
export const UPDATE_INVOICE_APPROVE_REQUEST = 'UPDATE_INVOICE_APPROVE_REQUEST';  
export const UPDATE_INVOICE_APPROVE_SUCCESS = 'UPDATE_INVOICE_APPROVE_SUCCESS';  
export const UPDATE_INVOICE_APPROVE_FAILURE = 'UPDATE_INVOICE_APPROVE_FAILURE';  

// Invoice Reject
export const UPDATE_INVOICE_REJECT_REQUEST  = 'UPDATE_INVOICE_REJECT_REQUEST';   
export const UPDATE_INVOICE_REJECT_SUCCESS  = 'UPDATE_INVOICE_REJECT_SUCCESS';   
export const UPDATE_INVOICE_REJECT_FAILURE  = 'UPDATE_INVOICE_REJECT_FAILURE';   


export const WS_CONNECT_REQUEST   = "WS_CONNECT_REQUEST";      
export const WS_CONNECT_SUCCESS   = "WS_CONNECT_SUCCESS";      
export const WS_CONNECT_FAILURE   = "WS_CONNECT_FAILURE";      

export const WS_DISCONNECT        = "WS_DISCONNECT";           

export const WS_MESSAGE_RECEIVED  = "WS_MESSAGE_RECEIVED";     
export const WS_STATUS_SET_LOADING = "WS_STATUS_SET_LOADING";  

export const PAYMENT_STATUS_DATA_REQUEST   = "PAYMENT_STATUS_DATA_REQUEST";
export const PAYMENT_STATUS_DATA_SUCCESS   = "PAYMENT_STATUS_DATA_SUCCESS";
export const PAYMENT_STATUS_DATA_FAILURE   = "PAYMENT_STATUS_DATA_FAILURE";

export const UPDATE_ACCEPTPO_REQUEST = "UPDATE_ACCEPTPO_REQUEST";
export const UPDATE_ACCEPTPO_SUCCESS = "UPDATE_ACCEPTPO_SUCCESS";
export const UPDATE_ACCEPTPO_FAILURE = "UPDATE_ACCEPTPO_FAILURE";

export const UPDATE_ACCEPT_PAYMENT_REQUEST = "UPDATE_ACCEPT_PAYMENT_REQUEST"; 
export const UPDATE_ACCEPT_PAYMENT_SUCCESS = "UPDATE_ACCEPT_PAYMENT_SUCCESS"; 
export const UPDATE_ACCEPT_PAYMENT_FAILURE = "UPDATE_ACCEPT_PAYMENT_FAILURE"; 
